exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1R2CYEG_XIIlRH1BIBY65e{outline:none;max-width:none;max-height:none}", ""]);
// Exports
exports.locals = {
	"dialog": "_1R2CYEG_XIIlRH1BIBY65e"
};